import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

const Location = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="location padding" style={{ paddingBottom: "30px" }}>
        <div className="container">
          <div className="heading">
            <h1>{t("testimonials_title")}</h1>
            <p>{t("testimonials_subtitle")}</p>
          </div>

          <br />

          <div className="row">
            {/* Testimonial 1 */}
            <div className="col-lg-4">
              <div className="box center3">
                <img className="imgcircle" alt="" src="./images/user1.jpg" />
                <br />

                <p
                  className="testcolor"
                  style={{ borderRight: "1px solid #72809d", padding: "20px" }}
                >
                  {t("feedback1_text")}
                </p>

                <h5 className="hmargin">{t("feedback1_name")}</h5>
                <p className="testcolor1">{t("feedback1_role")}</p>

                <p className="starcolor">
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                </p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="col-lg-4">
              <div className="box center3">
                <img className="imgcircle" alt="" src="./images/user2.jpg" />
                <br />

                <p
                  className="testcolor"
                  style={{ borderRight: "1px solid #72809d", padding: "20px" }}
                >
                  {t("feedback2_text")}
                </p>

                <h5 className="hmargin">{t("feedback2_name")}</h5>
                <p className="testcolor1">{t("feedback2_role")}</p>

                <p className="starcolor">
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                </p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="col-lg-4">
              <div className="box center3">
                <img className="imgcircle" alt="" src="./images/user3.jpg" />
                <br />

                <p className="testcolor" style={{ padding: "20px" }}>
                  {t("feedback3_text")}
                </p>

                <h5 className="hmargin">{t("feedback3_name")}</h5>
                <p className="testcolor1">{t("feedback3_role")}</p>

                <p className="starcolor">
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Location;
